/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_TiredInputs */

const en_us2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tired`)
};

const pt_br2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cansado`)
};

const es_419_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cansado`)
};

const pt_pt2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cansado`)
};

const fr_fr2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fatigué`)
};

const de_de2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`müde`)
};

const it_it2_recovery_tired = /** @type {(inputs: Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`affaticato`)
};

/**
* | output |
* | --- |
* | "tired" |
*
* @param {Recovery_TiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_tired = /** @type {((inputs?: Recovery_TiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_TiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_tired(inputs)
	if (locale === "es-419") return es_419_recovery_tired(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_tired(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_tired(inputs)
	if (locale === "de-DE") return de_de2_recovery_tired(inputs)
	if (locale === "it-IT") return it_it2_recovery_tired(inputs)
	return en_us2_recovery_tired(inputs)
});
export { recovery_tired as "recovery.tired" }